import React from "react";
import { VMProvider } from "../../commons/base/providers/provider";
import FormOpsReminderListViewModel from "./view_models/form_ops_reminder_list_view_model";
import Scaffold from "../../commons/scaffold/scaffold";
import FormOpsReminderListSearchBarWidget from "./widgets/form_ops_reminder_list_search_bar_widget";
import FormOpsReminderTableWidget from "./widgets/form_ops_reminder_table_widget";
import { Link } from "react-router-dom";
import FormOpsReminderListSendModalWidget from "./widgets/form_ops_reminder_list_send_modal_widget";

export default class FormOpsReminderListScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider create={() => new FormOpsReminderListViewModel()}>
                {(vm) => (
                    <Scaffold
                        isShowLoading={vm.isLoading}
                        loadingBackgroundType="semi_transparent"
                        showErrorView={vm.errorModel}
                        showSnackbar={vm.snackbarModel}
                    >
                        <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                Form Ops Reminder
                            </h1>

                            {/* Search Bar */}
                            <FormOpsReminderListSearchBarWidget />

                            {/* Table */}
                            <FormOpsReminderTableWidget />

                            {/* Create New Btn */}
                            <div className="fixed bottom-4 right-4">
                                <Link
                                    className="px-4 py-4 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
                                    to={"/form-ops-reminder/create"}
                                >
                                    Create New
                                </Link>
                            </div>

                            {/* Modal for sending once */}
                            {vm.isShowingModal && (
                                <FormOpsReminderListSendModalWidget />
                            )}
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
